import React, { useMemo } from 'react';
import _ from 'underscore';
import { BusinessClassSurveyProps } from './types';
import { Button } from '@trello/nachos/button';
import { forTemplate } from 'app/common/lib/util/i18n';

import styles from './BusinessClassListSurvey.less';

const format = forTemplate('business_class_survey');

export function bcReasons(): string[] {
  return [
    'advanced automations',
    'advanced admin permissions',
    'advanced checklists',
    'board collections',
    'board observers',
    'custom backgrounds and stickers',
    'large file attachments',
    'single data export',
    'unlimited power-ups',
    'unlimited team boards',
  ];
}

export function BusinessClassListSurvey({
  onSubmit,
  onDismiss,
}: BusinessClassSurveyProps) {
  const shuffledReasons = useMemo<string[]>(() => _.shuffle(bcReasons()), []);

  return (
    <>
      <label>
        <div className={styles.question}>{format('question')}</div>
      </label>
      <ul>
        {shuffledReasons.map((reason) => {
          return (
            <li key={reason}>
              <Button
                shouldFitContainer
                onClick={() => onSubmit(reason, false)}
              >
                {format(['reason', reason])}
              </Button>
            </li>
          );
        })}
        <li key="no-thanks">
          <Button shouldFitContainer onClick={onDismiss}>
            {format('no-thanks')}
          </Button>
        </li>
      </ul>
    </>
  );
}
